export default __webpack_public_path__ + "static/broadcastImg2-d115c9ea322927826cde61b522773578.webp";